import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-regisprospect',
  templateUrl: './regisprospect.component.html',
  styleUrls: ['./regisprospect.component.scss']
})
export class RegisprospectComponent implements OnInit {

  constructor(
    private route:ActivatedRoute,
		public rest:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
  ) { }
  
  registerForm: FormGroup;
  submitted = false;
  refid = '';
  loadingIcon = {
    invalid: false
  };
  regis:any = [];
  provinces:any = [];
  cities:any = [];
  districts:any = [];
  subdistricts:any = [];

  ngOnInit() {
    this.refid = this.route.snapshot.params.refid
    // console.log(this.refid);
    this.checkAccount(this.refid);
    
    this.registerForm = this.fb.group({
      ktp: ['', [Validators.minLength(16)]],
      idref: [''],
      nama: [''],
      address: [''],
      // no: [''],
      notlp: ['', Validators.minLength(10)],
      email: ['', Validators.email],
      province: [''],
      city: [''],
      district: [''],
      subdistrict: [''],
      rw: [''],
      rt: [''],
      // password: ['', [Validators.required, Validators.minLength(6)]],
      // confirmPassword: ['', Validators.required],
      // acceptTerms: [false, Validators.requiredTrue]
    });
  }

  // convenience getter for easy access to form fields
  get f(){
    return this.registerForm.controls;
  }

  checkAccount(accountid:any){
    // console.log(accountid);
    const params = {
      'accountid' : accountid
    }
    this.rest.checkAccount(params).subscribe((response:any) => {
      // console.log(this.regis,response.data);
      if (response.status) {
        this.loadingIcon.invalid = false;

        this.regis = response.data;
        this.getProvince();

      }else{
        this.loadingIcon.invalid = true;
      }
    });
  }

  getProvince(){
    const params = {
      'country_id': 1,
      'show': 'all'
    }
    this.rest.getProvince(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.provinces = response.data;

      }
    });
  }

  getCity(provinceid:any){
    const params = {
      'province_id': provinceid,
      'show': 'all'
    }
    this.rest.getCity(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.cities = response.data;

      }
    });
  }

  getDistrict(cityid:any){
    const params = {
      'city_id': cityid,
      'show': 'all'
    }
    this.rest.getDistrict(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.districts = response.data;

      }
    });
  }

  getSubdistrict(districtid:any){
    const params = {
      'district_id': districtid,
      'show': 'all'
    }
    this.rest.getSubdistrict(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.subdistricts = response.data;

      }
    });
  }

  onSubmit(){
    
    this.submitted = true;
    
    if (this.registerForm.invalid) {
      return;
    }

    // const _id = this.registerForm

    const id = this.regis.accountidreferral
    this.registerForm.get('idref').setValue(id);
    // console.log(id, " batas",this.registerForm.value);

    this.rest.setDataprospek(this.registerForm.value).subscribe((response:any) => {
      console.log(response);

      if (response.status == true) {

        this.router.navigate(['notifikasi/1']);

      } else {
        // console.log('not cover');
        this.router.navigate(['notifikasi/2']);

      } 
      // else {
        
      //   this.router.navigate(['notifikasi/3']);

      // }
    });
    
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }

}
